import {ModelDef} from '../../CORE/src/common/$models/ModelDef'
import {$appHook} from '../../CORE/src/common/$appHook/$appHook'
import {coreDefaultModels} from '../../CORE/src/front/AppInitializer/coreDefaultModels'

/**
 * directus_users モデルに ps_clinic カラムを追加する
 * $appHook 経由で ModelFactory 初期化前に差し込むことで、
 * initColumnDef が正しく適用される
 */
$appHook.on(
  '$CORE.ModelFactory.directus_users.init.before',
  ({ modelDefinition }) => {
    modelDefinition.columns.ps_clinic = {
      type: 'RELATIONSHIP_MANY_TO_ONE',
      label: '医院',
      validate: { notEmpty: true },
      relationshipManyToOne: {
        collectionName: 'ps_clinics',
        labelFormatter: (row) => {
          return row.name
        },
      },
      visible: false,
    }
  },
  'ps-extend-directus-users-with-clinic',
)

const models = {
  ...coreDefaultModels,
  // add here the project model definitions
}
export type TModelName = keyof typeof models
export default models as { [modelName: string]: ModelDef }
